<template>
  <div class="homecontainer _homecontainer">
<!--    <MainTop :titlename="'AEROSPACE'" :imgsrc="require('../../assets/imgs/airplane.png')"/>-->
    <Prodcontent :listdata="listdata"/>
    <Footer/>
  </div>
</template>
<script>
  import {getListProducts} from '@/api/home';
  import MainTop from '@/views/comcomponents/MainTop'
  import Footer from "@/views/comcomponents/Footer"
  import Prodcontent from "./procomponents/prodcontent";
  export default {
    name: 'Products',
    components: {
      MainTop,
      Prodcontent,
      Footer
    },
    data(){
      return{
        listdata:'',
      }
    },
    created() {
      this.getListProducts();
    },
    methods: {
      getListProducts() {
        getListProducts() .then(response => {
          const data = response.data;
          this.listdata=data.data;
        })
      },
    },
  }
</script>

<style lang="less" scoped>

  // 大于800px
  @media only screen and (min-width: 800px){
    .homecontainer{
      font-size: 1vw;
      .subdiv{
        width: 100%;
        display: flex;
        justify-content: space-around;
        font-size: .5em;
        .left{
          width: 48%;
          height: 100%;
          font-size: .8em;
        }
        .right{
          width: 48%;
          height: 100%;
          font-size: .8em;
        }
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px){
    ._homecontainer{
      font-size: 1.5vw;
      ._subdiv{
        width: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: space-around;
        font-size: .5em;
        .left{
          width: 100%;
          height: 100%;
          font-size: .8em;
        }
        .right{
          width: 100%;
          height: 100%;
          font-size: .8em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Products/Products.vue